import cn from "clsx";
import { Alignment } from "design-system/types/types";
import { useEffect, useState } from "react";

export interface IFrameFormEmbedProps {
  embedSourceUrl?: string;
  embedSourceTitle?: string;
  height?: string;
  align?: Alignment;
  formSource?: "machform" | "springshare" | "formassembly";
}

export function IFrameFormEmbed({
  embedSourceUrl,
  embedSourceTitle,
  height,
  align = "center",
  formSource,
}: IFrameFormEmbedProps) {
  const wrapperClass = cn(
    `hbs-global-align-${align}`,
    "hbs-component--iframe-form-embed",
  );

  const [defaultFormValues, setDefaultFormValues] = useState({});

  useEffect(() => {
    if (formSource === "machform") {
      const params = new URLSearchParams(window.location.search);
      const result: Record<string, string | null> = {};

      for (const [key, value] of params.entries()) {
        if (key.startsWith("form_")) {
          const newKey = key.replace("form_", "");
          result[newKey] = value;
        }
      }

      setDefaultFormValues(result);
    }
  }, [formSource]);

  const iframeSrc = () => {
    if (!embedSourceUrl) return;

    const url = new URL(embedSourceUrl);
    const urlParams = new URLSearchParams(url.search);
    Object.entries(defaultFormValues as Record<string, string>).forEach(
      ([key, value]) => {
        urlParams.set(key, value);
      },
    );
    url.search = urlParams.toString();

    return url.toString();
  };

  return (
    <div className={wrapperClass} data-region="cb__iframe-form-embed">
      <div className="hbs-iframe-form-embed">
        {embedSourceUrl ? (
          <iframe
            src={iframeSrc()}
            width="100%"
            height={height || 400}
            title={embedSourceTitle}
          />
        ) : null}
      </div>
    </div>
  );
}
